import { Stack, Typography } from "@mui/material"
import { colours } from "../../../StyleConstants"

type Props = {
    title: string
    hover?: boolean
    clickInfo?: any
    text: string
    skinny?: boolean
    deselected?: boolean
    handleClick?: Function
    onMouseOut?: Function
    mouseOutInfo?: number

}
const Selector = ({ title, hover = false, clickInfo = "", text, skinny = false, deselected = false, 
    handleClick = () => {}, onMouseOut = () => {}, mouseOutInfo = 0 }: Props) => {

    const getStyle = () => {
        if(!deselected){
            const hoverStyle = (hover) ? 
                {
                
                    '&:hover': {
                        backgroundColor: colours.orange.orange20,
                        border: `2px solid ${colours.orange.orange}`
                    },
                    borderRadius: "5px",
                    backgroundColor: colours.orange.orange10,
                
                } : {
                    border: "2px solid",
                    borderColor: colours.orange.orange,
                    backgroundColor: colours.orange.orange20
                }
            return hoverStyle
        }
        else{
            const hoverStyle = {
                borderRadius: "5px",
                backgroundColor: colours.orange.orange10,
            }
            return hoverStyle
        }

    }

    

    return(
        <Stack
            padding={2}
            height="100px"
            borderRadius="5px"
            sx={{
                cursor: 'pointer',
                height: skinny ? "auto" : "100px",
                ...getStyle()
            }}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            onClick={() => handleClick(clickInfo)}
            onMouseOut = {() => onMouseOut(mouseOutInfo)}
        >
            <Stack>
                <Typography variant="body1" fontWeight="600" color={colours.midnightBlue.blue}>
                    {title}
                </Typography>
                <Typography variant="body2" color={colours.gray.gray30}>
                    {text}
                </Typography>
            </Stack>
        </Stack>
    )
}

export default Selector